import '../../assets/css/breadcrumb.css'
export default function BreadCrumb({id = 'contact-us' , desc="Get free product consultation." , title="Connect Us For IT Support."}) {
    return (
        <div className="breadcrumb" id={id}>
            <div className="breadcrumb-text">
                <div className="breadcrumb-des">{desc}</div>
                <div className="breadcrumb-title"><h2>{title}</h2></div>
            </div>
        </div>
    )
}